<div class="modern-modal theme-fun">
  <div class="modal-header-icon">
    <i class="fas fa-exclamation"></i> 
  </div>

  <div class="modal-body">
    <h2 class="primary-message">{{primaryMessage}}</h2>
  </div>
  
  <div class="modal-actions">
    <button class="btn-action btn-success" (click)="clickHandler(true)">
      Yes
    </button>
     <button class="btn-action btn-danger" (click)="clickHandler(false)">
    Cancel
    </button>
  </div>
</div>